export const ewaKotecka = {
    'mydrId': 'ewakotecka',
    'firstName': 'Ewa',
    'lastName': 'Kotecka',
    'profession': 'Psycholog, psychoterapeuta integratywny w trakcie szkolenia, terapeuta EMDR',
    'avatar': 'ewa-kotecka.webp',
    'slug': 'psycholog-psychoterapeuta-ewa-kotecka',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'children'],
        ['psychology', 'consultation'],
    ]
}